import React, { useState } from 'react';

import 'react-alice-carousel/lib/alice-carousel.css';
import generalStyles from 'index.module.css';
import { useTranslation } from 'react-i18next';

import styles from 'sections/welcomeAnim/costumeVariations/costumeVariations.module.css';
import { Element } from 'react-scroll';
import { Popup } from 'components/popup/Popup';
import { ContactFormBookEventLazy } from 'components/contactFormBookEvent/ContactFormBookEventLazy';
import { MediaCarousel } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/MediaCarousel';
import { BlackSetItems } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/BlackSetItems';
import { RoseSetItems } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/RoseSetItems';
import { RedSetItems } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/RedSetItems';
import { ButterflyItems } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/ButterflyItems';
import { CandyCaneItems } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/CandyCane';
import { SnowItems } from './mediaCarousel/Snow';

export const CostumeVariations = () => {
    const { t } = useTranslation();
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    // const isFrenchLangSelected = i18n.resolvedLanguage === FR_LANG;
    const openClosePopup = () => {
        setIsPopupOpen(!isPopupOpen);
    };

    return (
        <section
            id="section-costume-variations"
            className={`${generalStyles.heightAuto}`}
        >
            <Element name="costumeVariations">
                <div
                    className={`${generalStyles.container} ${styles.container_costumeVariations}`}
                >
                    <div className={styles.costumeVariations}>
                        <h2 className={styles.costumeVariations__title}>
                            {t(
                                'welcomeAnim.costumeVariations.costumeVariationsTitle'
                            )}
                        </h2>
                        <div className={styles.costumeVariations__sets}>
                            <div className={styles.set}>
                                <div className={styles.set__gallery}>
                                    <MediaCarousel items={SnowItems} />
                                </div>
                                <div className={styles.set__info}>
                                    <h3>
                                        {t(
                                            'welcomeAnim.costumeVariations.snow'
                                        )}
                                    </h3>
                                    <button
                                        className={styles.set__infoBtn}
                                        onClick={openClosePopup}
                                    >
                                        {t('danceShow.bookNow')}
                                    </button>
                                </div>
                            </div>

                            <div className={styles.set}>
                                <div className={styles.set__gallery}>
                                    <MediaCarousel items={CandyCaneItems} />
                                </div>
                                <div className={styles.set__info}>
                                    <h3>
                                        {t(
                                            'welcomeAnim.costumeVariations.candyCane'
                                        )}
                                    </h3>
                                    <button
                                        className={styles.set__infoBtn}
                                        onClick={openClosePopup}
                                    >
                                        {t('danceShow.bookNow')}
                                    </button>
                                </div>
                            </div>

                            <div className={styles.set}>
                                <div className={styles.set__gallery}>
                                    <MediaCarousel items={ButterflyItems} />
                                </div>
                                <div className={styles.set__info}>
                                    <h3>
                                        {t(
                                            'welcomeAnim.costumeVariations.butterfly'
                                        )}
                                    </h3>
                                    <button
                                        className={styles.set__infoBtn}
                                        onClick={openClosePopup}
                                    >
                                        {t('danceShow.bookNow')}
                                    </button>
                                </div>
                            </div>

                            <div className={styles.set}>
                                <div className={styles.set__gallery}>
                                    <MediaCarousel items={BlackSetItems} />
                                </div>
                                <div className={styles.set__info}>
                                    <h3>
                                        {t(
                                            'welcomeAnim.costumeVariations.blackSet'
                                        )}
                                    </h3>
                                    <button
                                        className={styles.set__infoBtn}
                                        onClick={openClosePopup}
                                    >
                                        {t('danceShow.bookNow')}
                                    </button>
                                </div>
                            </div>

                            <div className={styles.set}>
                                <div className={styles.set__gallery}>
                                    <MediaCarousel items={RoseSetItems} />
                                </div>
                                <div className={styles.set__info}>
                                    <h3>
                                        {t(
                                            'welcomeAnim.costumeVariations.roseSеt'
                                        )}
                                    </h3>
                                    <button
                                        className={styles.set__infoBtn}
                                        onClick={openClosePopup}
                                    >
                                        {t('danceShow.bookNow')}
                                    </button>
                                </div>
                            </div>

                            <div className={styles.set}>
                                <div className={styles.set__gallery}>
                                    <MediaCarousel items={RedSetItems} />
                                </div>
                                <div className={styles.set__info}>
                                    <h3>
                                        {t(
                                            'welcomeAnim.costumeVariations.redSet'
                                        )}
                                    </h3>
                                    <button
                                        className={styles.set__infoBtn}
                                        onClick={openClosePopup}
                                    >
                                        {t('danceShow.bookNow')}
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/*<div className={styles.costumeVariations__sets}>*/}

                        {/*<div className={styles.set}>*/}
                        {/*    <div className={styles.set__comingsoon}>*/}
                        {/*        {isFrenchLangSelected ? (*/}
                        {/*            <OptimizedImg*/}
                        {/*                desktopSrc="https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/comingSoon/comingSoonFr%401x.png"*/}
                        {/*                mobileSrc="https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/comingSoon/comingSoonFr%401x.png"*/}
                        {/*            />*/}
                        {/*        ) : (*/}
                        {/*            <OptimizedImg*/}
                        {/*                desktopSrc="https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/comingSoon/comingSoonEn%401x.png"*/}
                        {/*                mobileSrc="https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/comingSoon/comingSoonEn%401x.png"*/}
                        {/*            />*/}
                        {/*        )}*/}
                        {/*    </div>*/}
                        {/*    <div className={styles.set__info}>*/}
                        {/*        <h3>*/}
                        {/*            {t(*/}
                        {/*                'welcomeAnim.costumeVariations.goldenSet'*/}
                        {/*            )}*/}
                        {/*        </h3>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </Element>

            <Popup isOpen={isPopupOpen} onClose={openClosePopup}>
                <ContactFormBookEventLazy onClose={openClosePopup} />
            </Popup>
        </section>
    );
};
